import { render, staticRenderFns } from "./ChapterImageModal.vue?vue&type=template&id=36ac7e4b&"
import script from "./ChapterImageModal.vue?vue&type=script&lang=js&"
export * from "./ChapterImageModal.vue?vue&type=script&lang=js&"
import style0 from "./ChapterImageModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports